module.exports = __webpack_public_path__ + "img/company.36864739.jpg";